<script lang="ts">
	import { companyPhone } from "../contacts/companyPhone.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import StructuredData from "./common/StructuredData.svelte";

	const { WEB_URL } = getGlobalSettings();
</script>

<StructuredData
	data={{
		"@type": "Organization",
		name: "Commarec",
		legalName: "Commarec s.r.o.",
		url: WEB_URL,
		logo: `${WEB_URL}/logo.png`,
		description:
			"Děláme logistiku jednoduše a efektivně. Pomáháme firmám mít sklady pod kontrolou, podporujeme jejich růst nebo nastavujeme procesy.",
		telephone: companyPhone,
		email: "info@commarec.cz",
		address: {
			"@type": "PostalAddress",
			streetAddress: "Varšavská 715/36",
			postalCode: "120 00",
			addressLocality: "Praha 2",
			addressCountry: "CZ",
		},
		contactPoint: {
			"@type": "ContactPoint",
			telephone: companyPhone,
			email: "info@commarec.cz",
			contactType: "customer service",
			areaServed: "CZ",
			availableLanguage: "Czech",
		},
		sameAs: ["https://www.linkedin.com/company/commarec/", "https://www.youtube.com/@commareclogistika"],
	}}
/>
